export default __webpack_public_path__ + "files/farmdoc-9a2975cb59fd3f627e9ed18a8824840f.png";